import { useEffect, useState } from "react";
import router, { useRouter } from "next/router";
import { BLOCK_RATINGS } from "~/const/block-ratings";
import { PATHS } from "~/const/paths";
import { useQueryString } from "~/hooks/use-query-string";
import { G_VideoRatingCategory, useGetVideoQuery } from "~/lib/graphql";
import { useAuth } from "~/provider/auth";
import { getDevice, getPlayDevice } from "~/util/get-device";
import { isBot } from "~/util/is-bot";

export const useDetailRedirect = () => {
  const { isReady } = useRouter();
  const { season, content } = useQueryString();
  const { isLoggedIn } = useAuth();

  const [checkingRedirect, setIsCheckingRedirect] = useState(true);

  const { data: videoData } = useGetVideoQuery({
    fetchPolicy: "network-only",
    skip: !isReady || season === undefined,
    ssr: isBot(),
    variables: {
      seasonId: season,
      contentId: content ?? "",
      device: getDevice(),
      playDevice: getPlayDevice(),
      isLoggedIn,
      isContentId: content !== undefined,
    },
  });

  const videoCategory = videoData?.video.rating.category;

  /**
   * MEMO:SEO案件
   * 未ログイン:vod/detailにアクセス
   * ログイン: モーダル末端に遷移
   */
  const effectReplace = () => {
    if (!videoCategory) return;
    if (isLoggedIn) {
      const isGravure = videoCategory === G_VideoRatingCategory.R18Gravure;
      router.replace({
        pathname: isGravure ? PATHS.VOD_GRAVURE : PATHS.VOD,
        query: router.query,
      });
      return;
    }
    const isBlockedRating = BLOCK_RATINGS.includes(videoCategory);
    isBlockedRating &&
      router.replace({
        pathname: PATHS.VOD_GRAVURE_DETAIL,
        query: router.query,
      });
    setIsCheckingRedirect(false);
  };

  useEffect(effectReplace, [videoCategory, isLoggedIn]);
  return {
    checkingRedirect,
  };
};
